const state = {
  featureFlags: {},
};

const getters = {
  all(state) {
    return state.featureFlags;
  },
  getFeatureFlagBySlug: state => slug => {
    return state.featureFlags[slug] || false;
  },
};

const actions = {
  setFeatureFlags(context, { featureFlags }) {
    context.commit('setFeatureFlags', { featureFlags });
  },
};

const mutations = {
  setFeatureFlags(state, { featureFlags }) {
    state.featureFlags = featureFlags;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
